<template>
  <div class="device-ct">
    <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
    <div class="nav">
      <div class="module-title">
        <h1>MRI教学实训设备</h1>
      </div>

      <div class="ct-content">
        <!-- 文字在上，图片垂直在下 单栏布局 -->
        <div class="single-col-card">
          <div class="text-wrap">
            <p class="text-content">{{ p[0] }}</p>
            <p class="text-content">{{ p[1] }}</p>
          </div>
          <!-- 设备图片行 -->
          <el-row :gutter="18" class="img-row" style="display: flex;align-items: center;">
            <el-col :xs="12" :sm="12" v-for="(item,index) in img" :key="index">
              <div class="main-banner imgLimit">
                <img :src="item" alt="MRI教学实训设备整机外观" class="banner-img" loading="lazy" />
                <div class="banner-glow"></div>
              </div>
            </el-col>
          </el-row>
          <!-- 分类模块卡片组件 -->
          <CardBorder :h6="h6" :msg="listP" :img="0" :tip="tip"></CardBorder>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardBorder from "./cardBorder.vue"
import { fenHaoArray } from '@/js/pdArray.js'
import PullDown from "@/components/home/pullDown.vue"

export default {
  props: {
    hidePullDown: {
      type: Boolean,
      default: false // 默认显示
    }
  },
  name: "HardMRI",
  components:{
    CardBorder,
    PullDown
  },
  data(){
    return{
      wWidth: window.innerWidth,
      p:[
        "MRI教学机模拟医院真实设备，设计与临床影像检查、图像采集、图像处理功能相似的MRI模拟机系统。模拟机主要由机架、自动检查床、扫描控制台、患者紧急呼叫装置-防磁气动报警、主控计算机系统、图像处理系统及相关辅助设备组成。",
        "MRI教学机可以用来提供对于 MRI 检查技术内容的临床技能操作教学和临床思维训练。满足临床检查技术实训要求。"
      ],
      h6:[
        "扫描机架系统",
        "扫描床系统",
        "线圈",
        "控制面板",
        "主控计算机系统",
        "MRI教学设备操作系统软件",
        "MRI图像后处理工作站",
        "MRI图像后处理软件"
      ],
      tip: ["（线圈可根据需求定制）","(具体参数功能请联系客服)"],
      listP:[],
      img:[
        require('@/assets/hardMRI1.png'),
        require('@/assets/hardMRI2.png')
      ]
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wWidth = window.innerWidth;
    }
  },
  created(){
    let a = new Array(8)
    a[2] = '①多通道头部线圈  ②多通道脊柱线圈 ③小柔线圈。'
    a[5] = `（1）具备病人基本信息登记、管理功能；
    （2）具备定位像显示、操作、处理及定位参数设置功能，能实现利用定位激光灯实现各个部位的精准定位功能；
    （3）具备图像显示，图像浏览，图像处理功能；
    （4）扫描部位如下：
            头颅检查：脑、垂体、颅脑MRA；
            脊柱检查：颈椎、胸椎、腰椎；
            体部检查：胸部、腹部、盆腔；
            四肢关节：腕关节、肘关节、肩关节、膝关节、踝关节；
            特殊部位：心脏、乳腺、颞下颌关节；
            全身成像功能：全脊柱拼接、全身弥散类PET成像等。
    （5）可进行图像处理，调整窗宽及窗位；图像放大与预览各种扫描序列图像显示；图像标注；图像中进行距离和角度测量；图像区域信号强度测量等。图像进行排版单幅、多幅、一键拍片、发送等功能。`
    a[7] = '基础后处理功能；血管分析模块；心脏冠脉分析模块；肝脏分析与术前手术规划模块等。'

    let a5 = [], a7 = []

    // ----------- a[5]处理 以（ 分块 -----------
    let a5split = a[5].split('（')
    a5split.forEach((val)=>{
        a5.push('（' + val)
    })

    a5[4] = a5[4].split('；')
    a5[4][0] = a5[4][0].split('头')
    let k = []
    k.push(a5[4][0][0])
    k.push('头'+a5[4][0][1])
    k = k.concat(a5[4].slice(1))
    a5[4] = k

    // a5F 拼成新数组
    let a5F = []
    a5F.push(a5[1])
    a5F.push(a5[2])
    a5F.push(a5[3])
    a5F.push(a5[4][0])
    for(let i=1;i<a5[4].length-1;i++){
        a5F.push(a5[4][i] + ('；'))
    }
    a5F.push(a5[4][a5[4].length-1])
    a5F.push(a5[5])

    a[5] = a5F

    // ----------- a[7]处理 以；分块  -----------
    a[7] = fenHaoArray(a[7])
    this.listP = a
  }
};
</script>

<style lang="scss" scoped>
.device-ct {
  width: 100%;
  padding: 1rem;
  margin-top: 80px;
  background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
  box-sizing: border-box;

  @media (max-width: 767px) {
    margin-top: 60px;
    padding: 0.5rem;
  }

  .nav {
    width: 60%;
    margin: 0 auto;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
                0 8px 24px rgba(37, 75, 156, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    margin-top: 20px;

    @media (max-width: 1024px) {
      width: 80%;
    }
    @media (max-width: 767px) {
      width: 100%;
      border-radius: 16px;
      box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
    }

    &:hover {
      box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
    }
  }

  .module-title {
    padding: 2.5rem 2rem 1.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a365d;
    text-align: center;
    letter-spacing: 0.04em;
    position: relative;
    background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    h1 {
      margin: 0;
      font-size: inherit;
      font-weight: inherit;
    }

    @media (max-width: 767px) {
      font-size: 1.25rem;
      padding: 1.5rem 1rem 1rem;
      gap: 8px;
    }

    &::after {
      content: "";
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .ct-content {
    padding: 2.5rem 3rem 3rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 48px;

    @media (max-width: 1024px) {
      padding: 2rem 2rem 2.5rem;
      gap: 36px;
    }
    @media (max-width: 767px) {
      padding: 1.5rem 1rem 1.5rem;
      gap: 28px;
    }
  }

  .single-col-card {
    background: #fff;
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    margin: auto;
  }

  // 全局统一标准文字样式（与CT/DR/MRI硬件、性能页面完全一致）
  .text-content {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 0.95rem;
    line-height: 2;
    color: #1e293b;
    text-align: justify;
    letter-spacing: 0.01em;
    position: relative;
    padding-left: 1rem;
    border-left: 3px solid transparent;

    @media (max-width: 767px) {
      font-size: 0.85rem;
      line-height: 1.85;
      padding-left: 0.75rem;
    }

    &:first-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(59, 130, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }

    &:last-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(139, 92, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }
  }

  // 图片行间距
  .img-row {
    margin-top: 16px;
  }

  // 图片卡片统一大图样式
  .imgLimit.main-banner {
    position: relative;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 8px 30px rgba(26, 75, 140, 0.12);
    max-width: 439px;
    width: 100%;

    @media only screen and (max-width: 767px){
      max-width: 100%;
    }
  }
  .banner-img {
    width: 100%;
    display: block;
    transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  .main-banner:hover .banner-img {
    transform: scale(1.035);
  }
  .banner-glow {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 45%;
    background: linear-gradient(to top, rgba(26, 75, 140, 0.22), transparent);
    pointer-events: none;
  }
}

// 暗色模式完整适配（全系列页面统一逻辑）
@media (prefers-color-scheme: dark) {
  .device-ct {
    background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

    .nav {
      background: rgba(20, 30, 50, 0.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .module-title {
        color: #93bbfc;
        background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);
        &::after {
          background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
        }
      }

      .ct-content {
        background: #0f1a2e;

        .single-col-card {
          background: #142033;
        }
        .text-content {
          color: #c8d6e8;
          &:first-of-type {
            background: linear-gradient(90deg, rgba(59, 130, 246, 0.08) 0%, transparent 100%);
          }
          &:last-of-type {
            background: linear-gradient(90deg, rgba(139, 92, 246, 0.08) 0%, transparent 100%);
          }
        }
      }
    }
  }
}

// 全局导航统一穿透样式
:deep .global-nav[data-v-5e75b752]{
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
  color: #0f3059;
  background: transparent;
}
</style>